export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/api',
  userAppUrl: 'https://web-eight-theta-70.vercel.app/',
  supabase: {
    url: 'https://onsfegadluofjyklzytx.supabase.co',
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9uc2ZlZ2FkbHVvZmp5a2x6eXR4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE2MjAzNDcsImV4cCI6MjA3NzE5NjM0N30.T9vLkNL3K90yn7iABmgktXVMznrp0uXzzrmMQFZ-aws'
  },
  importUsersTemplateUrl: 'https://onsfegadluofjyklzytx.supabase.co/storage/v1/object/public/ipay_uploads/resources/import-users-template.xlsx',
  importUsersBusinessTemplateUrl: 'https://onsfegadluofjyklzytx.supabase.co/storage/v1/object/public/ipay_uploads/resources/import-users-business-template.xlsx'
};